import React, { useState, useEffect } from "react";

const MemoInput = ({ customerId, initialValue = "", onSave }) => {
  const [value, setValue] = useState(initialValue);
  const [isSaving, setIsSaving] = useState(false);
  const [isComposing, setIsComposing] = useState(false);

  // 初期値が変更された時のみvalueを更新
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleSave = async () => {
    if (value !== initialValue && !isSaving) {
      setIsSaving(true);
      try {
        await onSave(customerId, value);
      } catch (error) {
        console.error("メモ保存エラー:", error);
        // エラー時は元の値に戻す
        setValue(initialValue);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const handleBlur = () => {
    handleSave();
  };

  const handleKeyDown = (e) => {
    // 日本語入力中（IME変換中）の場合はエンターキーを無視
    if ((e.key === "Enter" && isComposing) || (e.key === " " && isComposing)) {
      return;
    }

    if (e.key === "Enter") {
      // Shift+Enterの場合は改行を許可
      if (e.shiftKey) {
        return;
      }
      
      // Enterのみの場合は保存
      e.preventDefault(); // デフォルトの改行を防止
      handleSave();
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  return (
    <textarea
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      onCompositionStart={handleCompositionStart}
      onCompositionEnd={handleCompositionEnd}
      placeholder="メモを入力... (Shift+Enterで改行、Enterで保存)"
      disabled={isSaving}
      rows={1}
      style={{
        opacity: isSaving ? 0.6 : 1,
        cursor: isSaving ? "wait" : "text",
        resize: "vertical",
        minHeight: "24px",
        maxHeight: "200px"
      }}
    />
  );
};

// 一覧の各行に textarea を描画するため、親（顧客一覧）の再描画で
// 全行が作り直されないよう memo 化。props(customerId/initialValue/onSave)が
// 変わらない行は再描画をスキップする。
export default React.memo(MemoInput);
